import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import messages from 'i18n/messages/gridView';
import { Row, Col, Typography, Modal, Tooltip, Button } from 'antd';
import './AbandonDialog.less';
const AbandonDialog = (props) => {
  const {
    visibleSelection,
    handleModalAbandon,
    handleModalAppend,
    handleModalCancel,
    isSelectAllSearchResult,
    handleModalYes,
  } = props;
  return (
    <Modal
      title={
        isSelectAllSearchResult ? (
          'This action will unselect the currently selected items. Do you want to continue?'
        ) : (
          <FormattedMessage {...messages.titleModal} />
        )
      }
      visible={visibleSelection}
      closable={false}
      footer={[
        isSelectAllSearchResult ? (
          <Tooltip key='yes' title='Yes'>
            <Button type='primary' onClick={handleModalYes}>
              Yes
            </Button>
          </Tooltip>
        ) : null,
        isSelectAllSearchResult ? null : (
          <Tooltip
            key='abandon'
            title={<FormattedMessage {...messages.abandonTooltip} />}
          >
            <Button type='primary' onClick={handleModalAbandon}>
              <FormattedMessage {...messages.abandon} />
            </Button>
          </Tooltip>
        ),
        isSelectAllSearchResult ? null : (
          <Tooltip
            key='append'
            title={<FormattedMessage {...messages.appendTooltip} />}
          >
            <Button type='primary' onClick={handleModalAppend}>
              <FormattedMessage {...messages.append} />
            </Button>
          </Tooltip>
        ),
        <Tooltip
          key='cancel'
          title={<FormattedMessage {...messages.cancelTooltip} />}
        >
          <Button onClick={handleModalCancel}>
            <FormattedMessage {...messages.cancel} />
          </Button>
        </Tooltip>,
      ]}
    >
      <Row>
        <Col span={24}>
          <Typography.Text>
            <FormattedMessage {...messages.option} />
          </Typography.Text>
        </Col>
        {isSelectAllSearchResult && (
          <Col span={24} className='abandon-selection__col'>
            <Typography.Text className='abandon-selection__text'>
              Unselect all previously selected items.
            </Typography.Text>
          </Col>
        )}
        {isSelectAllSearchResult && (
          <Col span={24} className='abandon-selection__col'>
            <Typography.Text className='abandon-selection__text'>
              Keep the current selection.
            </Typography.Text>
          </Col>
        )}
        {!isSelectAllSearchResult && (
          <Col span={24} className='abandon-selection__col'>
            <Typography.Text className='abandon-selection__text'>
              <FormattedMessage {...messages.abandonTooltip} />
            </Typography.Text>
          </Col>
        )}
        {!isSelectAllSearchResult && (
          <Col span={24} className='abandon-selection__col'>
            <Typography.Text className='abandon-selection__text'>
              <FormattedMessage {...messages.appendTooltip} />
            </Typography.Text>
          </Col>
        )}
        {!isSelectAllSearchResult && (
          <Col span={24} className='abandon-selection__col'>
            <Typography.Text className='abandon-selection__text'>
              <FormattedMessage {...messages.cancelTooltip} />
            </Typography.Text>
          </Col>
        )}
      </Row>
    </Modal>
  );
};
AbandonDialog.propTypes = {
  visibleSelection: PropTypes.bool.isRequired,
  handleModalAbandon: PropTypes.func.isRequired,
  handleModalAppend: PropTypes.func.isRequired,
  handleModalCancel: PropTypes.func.isRequired,
};

export default AbandonDialog;
